import {FIGURE_CLASS} from './constants';

const youtubeScriptSrc = 'https://www.youtube.com/iframe_api';
const youtubeScript = document.createElement( 'script' );

let readyFunctions = [];

const initAfterApiReady = () => {
	readyFunctions.forEach( ( initFunction ) => initFunction() );

	readyFunctions = [];
};

const initYouTubeVideo = ( videoWrapper, videoContainer, youtubeVideoId, youtubeStartTime ) => {
	if ( !videoWrapper || !videoContainer || !youtubeVideoId )
	{
		return;
	}
	
	if ( !document.head.contains( youtubeScript ) )
	{
		youtubeScript.src = youtubeScriptSrc;
		document.head.appendChild( youtubeScript );
	}
	
	const initPlayer = () => {
		if ( !window.YT )
		{
			return;
		}
		
		const adjustPlayer = () => {
			const playerCoords = player.getIframe().getBoundingClientRect();
				
			if ( playerCoords.width > 0 )
			{
				const newHeight = Math.round( playerCoords.width / ( player.getIframe().width / player.getIframe().height ) );
				player.getIframe().parentElement.style.height = `${newHeight}px`;
			}
		};
		
		const onPlayerReady = () => {
			adjustPlayer();
		};
		
		const player = new window.YT.Player(
			videoContainer,
			{
				videoId: youtubeVideoId,
				playerVars: {
					start: youtubeStartTime,
				},
				events: {
					'onReady': onPlayerReady,
				},
			},
		);
		
		window.addEventListener( 'resize', () => {
			adjustPlayer();
		} );
		
		adjustPlayer();
		
		player.getIframe().classList.add( 'youtube' );
		videoWrapper.classList.add( FIGURE_CLASS.LOADED );
		videoWrapper.classList.remove( FIGURE_CLASS.LOADING );

		const handleInitClick = () => {
			videoWrapper.classList.add( FIGURE_CLASS.CLICKED );
			videoWrapper.classList.remove( FIGURE_CLASS.SHOW_COVER );
			videoWrapper.classList.remove( FIGURE_CLASS.SHOW_VIDEO_COVER );

			player.playVideo();

			videoWrapper.removeEventListener( 'click', handleInitClick );
		};

		videoWrapper.addEventListener( 'click', handleInitClick );
	};
	
	readyFunctions.push( initPlayer );
	
	if ( window.YT )
	{
		initAfterApiReady();
	}
	else
	{
		window.onYouTubeIframeAPIReady = initAfterApiReady;
	}
};

export {
	initYouTubeVideo,
};
